webpackJsonp([4],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	var _bootstrap = __webpack_require__(76);
	
	var _bootstrap2 = _interopRequireDefault(_bootstrap);
	
	var _slick = __webpack_require__(75);
	
	var _slick2 = _interopRequireDefault(_slick);
	
	var _modal = __webpack_require__(73);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _loadRsForm = __webpack_require__(72);
	
	var _loadRsForm2 = _interopRequireDefault(_loadRsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrap2.default)('#app');
	
	(0, _loadRsForm2.default)(__webpack_require__(119));
	
	'use strict';
	(function ($) {
	    $(document).ready(function () {
	
	        var BODY = $('body');
	
	        // Popups
	        new _modal2.default('.popup', '.popup-content', {
	            overlayClose: false
	        });
	
	        // console.log(RSFormPro);
	
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        /*Support placeholder*/
	        (function () {
	            $('input, textarea').placeholder();
	        })();
	        // ie9
	        BODY.on('change, click', function () {
	            (function () {
	                $('input, textarea').placeholder();
	            })();
	        });
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        //слайдер: главный, партнеры
	        (function () {
	            var $sliderMain = $('.slider-main');
	
	            if ($sliderMain.length) {
	                (0, _slick2.default)('.slider-partners ul', {
	                    slidesToShow: 5,
	                    variableWidth: true
	                });
	
	                (0, _slick2.default)($sliderMain, {
	                    speed: 500,
	                    fade: true
	                });
	                $sliderMain.find('article').each(function (e) {
	                    var src = $(this).attr('data-src');
	                    $(this).css({ backgroundImage: "url(" + src + ")" });
	                });
	
	                // Стилизация заголовков
	                $sliderMain.find('h1.title').each(function (i, el) {
	                    var $el = $(el);
	                    var text = $el.text().trim().split(' ');
	                    var first = text.shift();
	
	                    $el.html((text.length ? '<strong>' + first + '</strong>' : first) + ' ' + text.join(' '));
	                });
	
	                // позиционирование стрелок
	                var left = $sliderMain.find('.inner-wrapper').offset().left - 15,
	                    right = left + $sliderMain.find('.inner-wrapper').width();
	                $sliderMain.find('.slick-prev').css({ left: left + "px" });
	                $sliderMain.find('.slick-next').css({ left: right + "px" });
	            }
	        })();
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        // позиционирование блока контакты
	        (function () {
	            if ($('.map-contacts').length) {
	                var left = BODY.width() / 2;
	                $('.map-contacts').css({ left: left - 400 + "px" });
	            }
	        })();
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        // добавление адптивных стрелок к навигации в сайдбаре
	        $('.active').parent().css({ display: 'block' });
	        $('.category-nav .child > li').append('<div class="arrow"></div>');
	        $('.category-nav .child > li').each(function (e) {
	            var size = $(this).outerHeight() / 2;
	            $(this).find(".arrow").css({
	                borderTop: size + "px solid transparent",
	                borderBottom: size + 'px solid transparent',
	                borderLeft: 12.5 + 'px solid #660a18'
	            });
	        });
	
	        // раскрывающийся список (страница: Услуги по регистрации)
	        $('.list-registration .parent').on('click', function () {
	            if ($(this).hasClass("open") == false) {
	                $(this).addClass('open').find('.child').slideDown();
	            } else if ($(this).hasClass("open") == true) {
	                $(this).removeClass('open').find('.child').slideUp();
	            }
	        });
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        // костыль, создание 2 колонок ie9+ (страница: Услуга по регистрации)
	        $(function () {
	            var num_cols = 2,
	                container = $('.list-registration'),
	                listItem = '.parent',
	                listClass = 'sub-list';
	            container.each(function () {
	                var items_per_col = new Array(),
	                    items = $(this).find(listItem),
	                    min_items_per_col = Math.floor(items.length / num_cols),
	                    difference = items.length - min_items_per_col * num_cols;
	                for (var i = 0; i < num_cols; i++) {
	                    if (i < difference) {
	                        items_per_col[i] = min_items_per_col + 1;
	                    } else {
	                        items_per_col[i] = min_items_per_col;
	                    }
	                }
	                for (var i = 0; i < num_cols; i++) {
	                    $(this).append($('<ul ></ul>').addClass(listClass));
	                    for (var j = 0; j < items_per_col[i]; j++) {
	                        var pointer = 0;
	                        for (var k = 0; k < i; k++) {
	                            pointer += items_per_col[k];
	                        }
	                        $(this).find('.' + listClass).last().append(items[j + pointer]);
	                    }
	                }
	            });
	        });
	
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        //плавная прокрутка к якорю
	        if ($('#contacts').length) {
	            anchor('#header nav li:last-child a', 700);
	        }
	        function anchor(elem, time) {
	            $(elem).on('click', function () {
	                $("html, body").animate({
	                    scrollTop: $($(this).attr("href")).offset().top + "px"
	                }, {
	                    duration: time,
	                    easing: "swing"
	                });
	                return false;
	            });
	        }
	
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        // костыль, создание 3 колонок ie9+
	        $(function () {
	            var num_cols = 3,
	                container = $('.form-services-block ul'),
	                listItem = 'li',
	                listClass = 'sub-list';
	            container.each(function () {
	                var items_per_col = new Array(),
	                    items = $(this).find(listItem),
	                    min_items_per_col = Math.floor(items.length / num_cols),
	                    difference = items.length - min_items_per_col * num_cols;
	                for (var i = 0; i < num_cols; i++) {
	                    if (i < difference) {
	                        items_per_col[i] = min_items_per_col + 1;
	                    } else {
	                        items_per_col[i] = min_items_per_col;
	                    }
	                }
	                for (var i = 0; i < num_cols; i++) {
	                    $(this).append($('<ul ></ul>').addClass(listClass));
	                    for (var j = 0; j < items_per_col[i]; j++) {
	                        var pointer = 0;
	                        for (var k = 0; k < i; k++) {
	                            pointer += items_per_col[k];
	                        }
	                        $(this).find('.' + listClass).last().append(items[j + pointer]);
	                    }
	                }
	            });
	        });
	
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        // стилизация input-file
	
	        /* плагин для стилизации input[type='file'] */
	        $.fn.bootstrapFileInput = function () {
	            this.each(function (i, elem) {
	                var $elem = $(elem);
	                // Maybe some fields don't need to be standardized.
	                if (typeof $elem.attr('data-bfi-disabled') != 'undefined') {
	                    return;
	                }
	                // Set the word to be displayed on the button
	                var buttonWord = 'Browse';
	                if (typeof $elem.attr('title') != 'undefined') {
	                    buttonWord = $elem.attr('title');
	                }
	                var className = '';
	                if (!!$elem.attr('class')) {
	                    className = ' ' + $elem.attr('class');
	                }
	                // Now we're going to wrap that input field with a Bootstrap button.
	                // The input will actually still be there, it will just be float above and transparent (done with the CSS).
	                if (!$(this).parent().hasClass('file-input-wrapper')) {
	                    $elem.wrap('<div class="file-input-wrapper' + className + '"></div>').parent().prepend($('<span></span>').html(buttonWord));
	                }
	            })
	            // After we have found all of the file inputs let's apply a listener for tracking the mouse movement.
	            // This is important because the in order to give the illusion that this is a button in FF we actually need to move the button from the file input under the cursor. Ugh.
	            .promise().done(function () {
	
	                // As the cursor moves over our new Bootstrap button we need to adjust the position of the invisible file input Browse button to be under the cursor.
	                // This gives us the pointer cursor that FF denies us
	                $('.file-input-wrapper').mousemove(function (cursor) {
	
	                    var input, wrapper, wrapperX, wrapperY, inputWidth, inputHeight, cursorX, cursorY;
	
	                    // This wrapper element (the button surround this file input)
	                    wrapper = $(this);
	                    // The invisible file input element
	                    input = wrapper.find("input");
	                    // The left-most position of the wrapper
	                    wrapperX = wrapper.offset().left;
	                    // The top-most position of the wrapper
	                    wrapperY = wrapper.offset().top;
	                    // The with of the browsers input field
	                    inputWidth = input.width();
	                    // The height of the browsers input field
	                    inputHeight = input.height();
	                    //The position of the cursor in the wrapper
	                    cursorX = cursor.pageX;
	                    cursorY = cursor.pageY;
	
	                    //The positions we are to move the invisible file input
	                    // The 20 at the end is an arbitrary number of pixels that we can shift the input such that cursor is not pointing at the end of the Browse button but somewhere nearer the middle
	                    var moveInputX = cursorX - wrapperX - inputWidth + 20;
	                    // Slides the invisible input Browse button to be positioned middle under the cursor
	                    var moveInputY = cursorY - wrapperY - inputHeight / 2;
	
	                    // Apply the positioning styles to actually move the invisible file input
	                    input.css({
	                        left: moveInputX,
	                        top: moveInputY
	                    });
	                });
	
	                BODY.on('change', '.file-input-wrapper input[type=file]', function () {
	                    var fileName;
	                    fileName = $(this).val();
	
	                    if (fileName === '') {
	                        $(this).parent().removeClass('changed');
	                    } else if (fileName === undefined) {
	                        $(this).parent().removeClass('changed');
	                    } else {
	                        $(this).parent().addClass('changed');
	                    }
	                });
	            });
	        };
	        /* //плагин для стилизации input[type='file'] */
	
	        /* // стилизация input-file */
	
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	        // ширина раскрывающегося списка
	        //BODY.on('click', '.select-target', function(e){
	        //  e.stopPropagation();
	        //  var elWidth = $(this).width();
	        //  $('.select-content').css({width: elWidth + 63 + 'px'});
	        //});
	
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	        // Подсказки: парсинг, позиционирование
	        setTimeout(function () {
	            $("[data-tooltip]").each(function (e) {
	                if (!$(".form-services-block").has(this).length) {
	                    $(this).wrap('<div class="tooltip-wrapper"></div>');
	                }
	                var left = $(this).width() + 25,
	
	                // top =  '30px',
	                elem = '<div class="btn-tooltip" style="left:' + left + 'px">?</div>';
	
	                if ($(this)[0].tagName === "SELECT") {
	                    left = $(this).parent().width() - 32;
	                    elem = '<div class="btn-tooltip" style="left:' + left + 'px; top: 40px;">?</div>';
	                    $(this).after(elem);
	                } else if ($(this).parent().parent()[0].tagName === "LABEL") {
	                    left = $(this).parent().next().width() + 35;
	                    elem = '<div class="btn-tooltip" style="left:' + left + 'px">?</div>';
	                    $(this).parent().parent().after(elem);
	                } else if ($(this).parent().hasClass('input-wrapper')) {
	                    left = $(this).parent().parent().width() + 35;
	                    elem = '<div class="btn-tooltip" style="left:' + left + 'px">?</div>';
	                    $(this).parent().parent().after(elem);
	                } else {
	                    $(this).after(elem);
	                }
	            });
	        }, 2000);
	
	        $('input').click(function (e) {
	            e.stopPropagation();
	        });
	
	        BODY.on('click', '.btn-tooltip', function (e) {
	            e.stopPropagation();
	
	            $('.tooltip-modal').remove();
	            var check = $(this).next().hasClass("tooltip-modal");
	            if (check == false) {
	                var tooltipContent = $(this).prev().attr('data-tooltip');
	                if (tooltipContent !== undefined) {
	                    BODY.append(' <div class="tooltip-modal"> ' + '<div class="closed">X</div> ' + '<div class="text-content">' + tooltipContent + '</div>' + ' </div>');
	                } else {
	                    tooltipContent = $(this).parent().find('input').attr('data-tooltip');
	                    BODY.append(' <div class="tooltip-modal"> ' + '<div class="closed">X</div> ' + '<div class="text-content">' + tooltipContent + '</div>' + ' </div>');
	                }
	            }
	            // настройки позиционирования tooltip
	            var height = $('.tooltip-modal').height();
	            var top = $(this).offset().top - height - 12;
	            var left = $(this).offset().left - 28;
	            $('.tooltip-modal').css({ top: top + "px", left: left + "px" });
	        });
	
	        $(document.body).on('click', '.tooltip-modal .closed, #wrap', function () {
	            $('.tooltip-modal').remove();
	        });
	        $(document.body).keydown(function (e) {
	            if (e.which === 27) {
	                $('.tooltip-modal').remove();
	            }
	        });
	
	        $('.form-services-block .btn-tooltip').each(function (e) {
	            var elem = $(this).parent().parent();
	            var btn = $(this).detach();
	            elem.append(btn);
	
	            var left = $(this).prev().width() + 35;
	            $(this).css({ left: left + "px" });
	        });
	
	        // end Подсказки: парсинг, позиционирование
	
	        BODY.on('click', '.toggle', function () {
	            var context = $(this);
	            var isClass = context.hasClass('toggle--show');
	            if (isClass) {
	                context.next('.toggle-block').slideToggle(function () {
	                    context.removeClass('toggle--show');
	                    context.addClass('toggle--hide');
	                });
	            } else {
	                context.next('.toggle-block').slideToggle(function () {
	                    context.removeClass('toggle--hide');
	                    context.addClass('toggle--show');
	                });
	            }
	        });
	
	        // Поочередный показ в таблицах цен на услуги. Страницы юр.услуг
	        $('.price--first, .price--second').hide();
	
	        $(document).on('click', '.toggle-first', function () {
	            $('.price--first').slideToggle();
	            $('.price--second').slideToggle();
	            // $('.toggle-block').slideToggle();
	        });
	
	        // $(document).on('click', '.toggle-second', function () {
	
	        // });
	        // END Поочередный показ цен
	
	        $('.toggle-block').each(function () {
	            $(this).after('<div class="clearfix"></div>');
	        });
	
	        $('.btn-card-file').on('click', function () {
	            $('.card-file-popup').fadeIn();
	        });
	
	        $('.card-file-popup__close').on('click', function () {
	            $('.card-file-popup').fadeOut();
	        });
	
	        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	        function setPositionArrow() {
	            if (!$('.slider-main').length) {
	                return;
	            }
	            var leftPosition = $('.slider-main .stack').offset().left;
	            $('.slider-main .slick-prev').offset({ left: leftPosition - 150 });
	            $('.slider-main .slick-next').offset({ left: leftPosition + 455 });
	        }
	        $('.slider-main').on('init', function () {
	            setPositionArrow();
	        });
	
	        $(window).on('resize', function () {
	            setPositionArrow();
	        });
	
	        /**
	         * Check if Selector is exist
	         * @param selector
	         * @type String
	         * @returns {boolean}
	         */
	        function isSelector(selector) {
	            return !!$(selector).length;
	        }
	
	        // Add class to service-page with list of subsections
	        if (isSelector('.services-page .list-registration')) {
	            $('#wrap').addClass('services-page__subsections');
	        }
	    });
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(20)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(26);
	var IE8_DOM_DEFINE = __webpack_require__(51);
	var toPrimitive = __webpack_require__(42);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(10);
	var createDesc = __webpack_require__(31);
	module.exports = __webpack_require__(8) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(52);
	var defined = __webpack_require__(33);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(40)('wks');
	var uid = __webpack_require__(32);
	var Symbol = __webpack_require__(7).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var core = __webpack_require__(19);
	var ctx = __webpack_require__(93);
	var hide = __webpack_require__(16);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(56);
	var enumBugKeys = __webpack_require__(34);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(10).f;
	var has = __webpack_require__(9);
	var TAG = __webpack_require__(18)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(40)('keys');
	var uid = __webpack_require__(32);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(28);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var core = __webpack_require__(19);
	var LIBRARY = __webpack_require__(36);
	var wksExt = __webpack_require__(44);
	var defineProperty = __webpack_require__(10).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(18);


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(83);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(82);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	var document = __webpack_require__(7).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(8) && !__webpack_require__(20)(function () {
	  return Object.defineProperty(__webpack_require__(50)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(49);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(36);
	var $export = __webpack_require__(27);
	var redefine = __webpack_require__(57);
	var hide = __webpack_require__(16);
	var has = __webpack_require__(9);
	var Iterators = __webpack_require__(35);
	var $iterCreate = __webpack_require__(97);
	var setToStringTag = __webpack_require__(38);
	var getPrototypeOf = __webpack_require__(104);
	var ITERATOR = __webpack_require__(18)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(26);
	var dPs = __webpack_require__(101);
	var enumBugKeys = __webpack_require__(34);
	var IE_PROTO = __webpack_require__(39)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(50)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(95).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(56);
	var hiddenKeys = __webpack_require__(34).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(9);
	var toIObject = __webpack_require__(17);
	var arrayIndexOf = __webpack_require__(92)(false);
	var IE_PROTO = __webpack_require__(39)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(16);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(33);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (bundle) {
	
	    for (var i in bundle) {
	        if (bundle.hasOwnProperty(i)) {
	            window[i] = bundle[i];
	        }
	    }
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(84);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(85);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = function () {
	    function Modal(selector) {
	        var wrap_selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	        (0, _classCallCheck3.default)(this, Modal);
	
	        if (!(selector instanceof jQuery)) {
	            selector = $(selector);
	        }
	
	        if (!selector.length) {
	            return;
	        }
	
	        this.wrap_selector = wrap_selector;
	        this.selector = selector;
	        this.options = options;
	        this.request = {
	            option: 'com_content',
	            view: 'article',
	            tmpl: 'component'
	        };
	
	        this.init();
	    }
	
	    (0, _createClass3.default)(Modal, [{
	        key: 'init',
	        value: function init() {
	            var $this = this,
	                targetUrl = '/',
	                request = this.request;
	
	            $('body').on('click', this.selector.selector, function (e) {
	                e.preventDefault();
	
	                var $selector = $(this),
	                    href = $selector.data('href'),
	                    contentId = $selector.data('id');
	
	                if (!contentId && !href) {
	                    return;
	                }
	
	                __webpack_require__.e/* nsure */(3, function (require) {/* WEBPACK VAR INJECTION */(function($) {
	                    __webpack_require__(71);
	
	                    var defaultOptions = {
	                        title: $selector.data('title') || 'Подтвердите действие',
	                        setTimeout: $selector.data('timeout') || false,
	                        overlay: true,
	                        documentStick: false,
	                        overlayClose: true
	                    },
	                        action = $selector.data('action');
	
	                    if ($selector.data('class')) {
	                        $this.options.class = $selector.data('class');
	                    }
	
	                    if ($selector.data('close')) {
	                        $this.options.close = $selector.data('close');
	                    }
	
	                    if ($selector.data('wrap')) {
	                        $this.wrap_selector = $selector.data('wrap');
	                    }
	
	                    var options = $.extend(defaultOptions, $this.options);
	
	                    request.id = contentId;
	
	                    if (href) {
	                        targetUrl = href;
	                        request = {
	                            tmpl: 'component'
	                        };
	                    }
	
	                    $('<div>').load(targetUrl + ' ' + $this.wrap_selector, request, function () {
	
	                        var self = $(this),
	                            content = self.find($this.wrap_selector);
	
	                        content.MODAL(options);
	
	                        __webpack_require__(74).default(content, action, self, $selector);
	                    });
	                
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(1)))});
	            });
	        }
	    }]);
	    return Modal;
	}();
	
	exports.default = Modal;
	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(80);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (selector) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    if (!selector) {
	        throw new Error('Selector is empty');
	    }
	
	    if (!(selector instanceof jQuery)) {
	        selector = $(selector);
	    }
	
	    if (!selector.length) {
	        return;
	    }
	
	    var defaultOptions = {};
	
	    options = (0, _assign2.default)(defaultOptions, options);
	
	    __webpack_require__.e/* nsure */(2, function (require) {/* WEBPACK VAR INJECTION */(function($) {
	        __webpack_require__(125);
	        __webpack_require__(121);
	        __webpack_require__(120);
	
	        $(selector).slick(options);
	    
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(1)))});
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (selector) {
	    if (!selector) {
	        throw new Error('Selector is empty');
	    }
	
	    selector = typeof selector === 'string' && document.querySelector(selector);
	
	    if (!selector) {
	        return;
	    }
	
	    __webpack_require__.e/* nsure */(0, function (require) {
	        var Vue = __webpack_require__(206),
	            Validator = __webpack_require__(208),
	            Resource = __webpack_require__(148),
	            App = __webpack_require__(138);
	
	        Vue.use(Validator);
	        Vue.use(Resource);
	        Vue.config.silent = true;
	        new Vue(App).$mount(selector);
	    });
	};

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(86), __esModule: true };

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(87), __esModule: true };

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(88), __esModule: true };

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(89), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(81);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(109);
	module.exports = __webpack_require__(19).Object.assign;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(110);
	var $Object = __webpack_require__(19).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113);
	__webpack_require__(111);
	__webpack_require__(114);
	__webpack_require__(115);
	module.exports = __webpack_require__(19).Symbol;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(112);
	__webpack_require__(116);
	module.exports = __webpack_require__(44).f('iterator');


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(17);
	var toLength = __webpack_require__(107);
	var toAbsoluteIndex = __webpack_require__(106);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(90);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(29);
	var gOPS = __webpack_require__(37);
	var pIE = __webpack_require__(30);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(7).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(49);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(54);
	var descriptor = __webpack_require__(31);
	var setToStringTag = __webpack_require__(38);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(16)(IteratorPrototype, __webpack_require__(18)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(32)('meta');
	var isObject = __webpack_require__(28);
	var has = __webpack_require__(9);
	var setDesc = __webpack_require__(10).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(20)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(29);
	var gOPS = __webpack_require__(37);
	var pIE = __webpack_require__(30);
	var toObject = __webpack_require__(58);
	var IObject = __webpack_require__(52);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(20)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(10);
	var anObject = __webpack_require__(26);
	var getKeys = __webpack_require__(29);
	
	module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(30);
	var createDesc = __webpack_require__(31);
	var toIObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(42);
	var has = __webpack_require__(9);
	var IE8_DOM_DEFINE = __webpack_require__(51);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(17);
	var gOPN = __webpack_require__(55).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(9);
	var toObject = __webpack_require__(58);
	var IE_PROTO = __webpack_require__(39)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(41);
	var defined = __webpack_require__(33);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(41);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(41);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(91);
	var step = __webpack_require__(98);
	var Iterators = __webpack_require__(35);
	var toIObject = __webpack_require__(17);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(53)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(27);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(100) });


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(27);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperty: __webpack_require__(10).f });


/***/ }),
/* 111 */
/***/ (function(module, exports) {



/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(105)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(53)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(7);
	var has = __webpack_require__(9);
	var DESCRIPTORS = __webpack_require__(8);
	var $export = __webpack_require__(27);
	var redefine = __webpack_require__(57);
	var META = __webpack_require__(99).KEY;
	var $fails = __webpack_require__(20);
	var shared = __webpack_require__(40);
	var setToStringTag = __webpack_require__(38);
	var uid = __webpack_require__(32);
	var wks = __webpack_require__(18);
	var wksExt = __webpack_require__(44);
	var wksDefine = __webpack_require__(43);
	var enumKeys = __webpack_require__(94);
	var isArray = __webpack_require__(96);
	var anObject = __webpack_require__(26);
	var toIObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(42);
	var createDesc = __webpack_require__(31);
	var _create = __webpack_require__(54);
	var gOPNExt = __webpack_require__(103);
	var $GOPD = __webpack_require__(102);
	var $DP = __webpack_require__(10);
	var $keys = __webpack_require__(29);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(55).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(30).f = $propertyIsEnumerable;
	  __webpack_require__(37).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(36)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(43)('asyncIterator');


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(43)('observable');


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(108);
	var global = __webpack_require__(7);
	var hide = __webpack_require__(16);
	var Iterators = __webpack_require__(35);
	var TO_STRING_TAG = __webpack_require__(18)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RSFormProCalendars = {};
	var RSFormProPrices = {};
	var ajaxExtraValidationScript = {};
	var RSClickedSubmitElement = false;
	
	if ((typeof RSFormPro === 'undefined' ? 'undefined' : (0, _typeof3.default)(RSFormPro)) != 'object') {
		var RSFormPro = {};
	}
	
	RSFormPro.Forms = {};
	RSFormPro.Editors = {};
	RSFormPro.scrollToError = false;
	
	/* Handle HTML5 form fields validation for the forms without AjaxValidation enabled */
	RSFormPro.setHTML5Validation = function (formId, isDisabledSubmit, layoutErrorClass) {
		var submitElement = RSFormPro.getElementByType(formId, 'submit');
		for (var i = 0; i < submitElement.length; i++) {
			if (RSFormProUtils.hasClass(submitElement[i], 'rsform-submit-button')) {
				RSFormProUtils.addEvent(submitElement[i], 'click', function (event) {
					errorElements = RSFormPro.HTML5.validation(formId);
					if (errorElements.length) {
						for (j = 0; j < errorElements.length; j++) {
							errorElements[j].field.className = errorElements[j].field.className.replace(' rsform-error', '') + ' rsform-error';
							if (document.getElementById('component' + errorElements[j].componentId)) {
								document.getElementById('component' + errorElements[j].componentId).className = 'formError';
							}
							if (layoutErrorClass) {
								try {
									var block = RSFormPro.getBlock(formId, RSFormProUtils.getAlias(errorElements[j].field.getAttribute('id')));
									block = block[0];
									block.className = block.className.replace(layoutErrorClass, '') + layoutErrorClass;
								} catch (err) {}
							}
						}
	
						if (RSFormPro.scrollToError) {
							RSFormPro.gotoErrorElement(formId);
						}
	
						if (isDisabledSubmit) {
							for (j = 0; j < submitElement.length; j++) {
								submitElement[j].disabled = false;
							}
						}
	
						event.preventDefault();
					} else {
						if (isDisabledSubmit) {
							// if the submit button or any other element has the id submit the form.submit() function is overwritten
							if (typeof this.form.submit != 'function') {
								document.createElement('form').submit.call(this.form);
							} else {
								this.form.submit();
							}
						}
					}
				});
			}
		}
	};
	
	/* Disable the submit button when form is submitted functions */
	RSFormPro.setDisabledSubmit = function (formId, ajaxValidation) {
		if (!ajaxValidation) {
			var submitElement = RSFormPro.getElementByType(formId, 'submit');
			for (i = 0; i < submitElement.length; i++) {
				if (RSFormProUtils.hasClass(submitElement[i], 'rsform-submit-button')) {
					RSFormProUtils.addEvent(submitElement[i], 'click', function (event) {
						for (j = 0; j < submitElement.length; j++) {
							submitElement[j].disabled = true;
						}
					});
				}
			}
		}
	};
	/* Thank You Message in Popup Window functions */
	
	RSFormPro.showThankYouPopup = function (thankYouContainer) {
		var content = thankYouContainer.innerHTML;
		var gotoUrl = thankYouContainer.querySelector('#rsfp-thankyou-popup-return-link').value;
	
		// remove the html part from the layout
		thankYouContainer.parentNode.removeChild(thankYouContainer);
	
		document.body.className = document.body.className + ' rsfp_popup_activated';
		document.body.innerHTML += '<div class="rsfp_thankyou_popup_outer" onclick="RSFormPro.accessLink(event,\'' + gotoUrl + '\')"><div class="rsfp_thankyou_popup_inner" id="rsfp_thankyou_popup_inner"><div class="rsfp_thankou_popup_close_btn">&times;</div>' + content + '</div></div>';
	
		var popupWindowHeight = document.getElementById('rsfp_thankyou_popup_inner').offsetHeight;
		var windowHeight = window.innerHeight;
	
		var marginTop = (windowHeight - popupWindowHeight) / 2;
		document.getElementById('rsfp_thankyou_popup_inner').style.marginTop = marginTop + 'px';
	};
	RSFormPro.accessLink = function (event, link) {
		var clickedElementClass = event.target.className;
		if (clickedElementClass == 'rsfp_thankyou_popup_outer' || clickedElementClass == 'rsfp_thankou_popup_close_btn') {
			if (link.length > 0) {
				document.location = link;
			} else {
				document.location.reload();
			}
		}
	};
	
	/* Scroll to first error element */
	RSFormPro.gotoErrorElement = function (formId) {
		var form = RSFormPro.getForm(formId);
		var errorElements = form.getElementsByClassName('formError');
		if (errorElements.length) {
			var block = RSFormPro.findAncestor(errorElements[0], 'rsform-block');
			if (block) {
				RSFormPro.scrollToElement(block);
			} else {
				RSFormPro.scrollToElement(errorElements[0]);
			}
		}
	};
	
	RSFormPro.findAncestor = function (el, cls) {
		while (el = el.parentElement) {
			var elementClasses = el.className;
			elementClasses = elementClasses.split(' ');
			if (elementClasses.indexOf(cls) >= 0) {
				return el;
			}
		}
	
		return false;
	};
	
	/* ScrollTo functions */
	RSFormPro.scrollToElement = function (element) {
		var to = element.offsetTop;
		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		var documentView = window.innerHeight + scrollTop;
	
		// this is more specific for the modern browsers
		if (typeof element.getBoundingClientRect == 'function') {
			to = element.getBoundingClientRect().top + scrollTop;
		}
	
		if (to < scrollTop || to > documentView) {
			RSFormPro.scrollTo(to, 300);
		}
	};
	
	RSFormPro.scrollTo = function (to, duration) {
		if (duration <= 0) return;
		var elementScrollTop = window.pageYOffset ? window.pageYOffset : document.documentElement.scrollTop;
		var difference = to - elementScrollTop;
		var perTick = difference / duration * 10;
	
		setTimeout(function () {
			var limitControl;
			limitControl = window.pageYOffset ? window.pageYOffset : document.documentElement.scrollTop;
			limitControl = limitControl + perTick;
			window.scrollTo(0, limitControl);
			// if the element has been reached or the scroll is at the bottom of the page no need to continue
			if (limitControl == to) return;
	
			RSFormPro.scrollTo(to, duration - 10);
		}, 10);
	};
	
	/* Field specific functions */
	
	RSFormPro.refreshCaptcha = function (componentId, captchaPath) {
		if (!captchaPath) {
			captchaPath = 'index.php?option=com_rsform&task=captcha&componentId=' + componentId;
		}
		document.getElementById('captcha' + componentId).src = captchaPath + '&' + Math.random();
		document.getElementById('captchaTxt' + componentId).value = '';
		document.getElementById('captchaTxt' + componentId).focus();
	};
	
	RSFormPro.initGeoLocation = function (term, id, mapid, map, marker, geocoder, type) {
		var content = document.getElementById('rsform_geolocation' + id);
		var address = document.getElementById(mapid).clientWidth;
	
		document.getElementById('rsform_geolocation' + id).style.width = address + 'px';
		document.getElementById('rsform_geolocation' + id).style.display = 'none';
		document.getElementById('rsform_geolocation' + id).innerHTML = '';
	
		if (term != '') {
			geocoder.geocode({ 'address': term }, function (results, status) {
				if (status == 'OK') {
					for (var i = 0; i < results.length; i++) {
						var item = results[i];
						var theli = document.createElement('li');
						var thea = document.createElement('a');
	
						thea.setAttribute('href', 'javascript:void(0)');
						thea.innerHTML = item.formatted_address;
	
						RSFormProUtils.addEvent(thea, 'click', function () {
							var mapValue = type ? item.formatted_address : item.geometry.location.lat().toFixed(5) + ',' + item.geometry.location.lng().toFixed(5);
							var mapId = mapid;
							var location = new google.maps.LatLng(item.geometry.location.lat().toFixed(5), item.geometry.location.lng().toFixed(5));
	
							return function () {
								document.getElementById(mapId).value = mapValue;
								marker.setPosition(location);
								map.setCenter(location);
								document.getElementById('rsform_geolocation' + id).style.display = 'none';
							};
						}());
	
						theli.appendChild(thea);
						content.appendChild(theli);
					}
	
					document.getElementById('rsform_geolocation' + id).style.display = '';
				}
			});
		}
	};
	
	RSFormPro.disableInvalidDates = function (fieldName) {
		var theDate = new Date(),
		    day,
		    index;
	
		for (day = 1; day <= 31; day++) {
			var year = parseInt(document.getElementById(fieldName + 'y').value);
			var month = parseInt(document.getElementById(fieldName + 'm').value) - 1;
	
			index = day - 1;
			if (document.getElementById(fieldName + 'd').options[0].value == '') {
				index++;
			}
			document.getElementById(fieldName + 'd').options[index].disabled = false;
			if (!isNaN(year) && !isNaN(month)) {
				if (typeof theDate.__msh_oldSetFullYear == 'function') {
					theDate.__msh_oldSetFullYear(year, month, day);
				} else {
					theDate.setFullYear(year, month, day);
				}
	
				if (theDate.getDate() != day || theDate.getMonth() != month) {
					document.getElementById(fieldName + 'd').options[index].disabled = true;
				}
			}
		}
		if (document.getElementById(fieldName + 'd').options[document.getElementById(fieldName + 'd').selectedIndex].disabled == true) {
			for (day = 31; day >= 28; day--) {
				index = day - 1;
				if (document.getElementById(fieldName + 'd').options[0].value == '') {
					index++;
				}
				if (document.getElementById(fieldName + 'd').options[index].disabled == false) {
					document.getElementById(fieldName + 'd').value = day;
					break;
				}
			}
		}
	};
	
	/* Number functions */
	
	RSFormPro.formatNumber = function (number, decimals, dec_point, thousands_sep) {
		var n = number,
		    prec = decimals;
		n = !isFinite(+n) ? 0 : +n;
		prec = !isFinite(+prec) ? 0 : Math.abs(prec);
		var sep = typeof thousands_sep == "undefined" ? ',' : thousands_sep;
		var dec = typeof dec_point == "undefined" ? '.' : dec_point;
	
		var s = prec > 0 ? n.toFixed(prec) : Math.round(n).toFixed(prec); //fix for IE parseFloat(0.55).toFixed(0) = 0;
	
		var abs = Math.abs(n).toFixed(prec);
		var _, i;
	
		if (abs >= 1000) {
			_ = abs.split(/\D/);
			i = _[0].length % 3 || 3;
	
			_[0] = s.slice(0, i + (n < 0)) + _[0].slice(i).replace(/(\d{3})/g, sep + '$1');
	
			s = _.join(dec);
		} else {
			s = s.replace('.', dec);
		}
	
		return s;
	};
	
	RSFormPro.toNumber = function (number, decimal, thousands, decimals) {
		// Remove decimals first
		if (parseInt(decimals) > 0 && number.lastIndexOf(decimal) > -1) {
			var index = number.lastIndexOf(decimal);
			number = number.substring(0, index) + 'DECIMALS' + number.substring(index + 1);
		}
	
		// Remove thousands separator
		if (number.indexOf(thousands) > -1) {
			number = number.split(thousands).join('');
		}
	
		number = number.split('DECIMALS').join('.');
		return parseFloat(number);
	};
	
	/* Form and element functions */
	
	RSFormPro.getForm = function (formId) {
		if (typeof RSFormPro.Forms[formId] == 'undefined') {
			var formIds = document.getElementsByName('form[formId]');
			for (var i = 0; i < formIds.length; i++) {
				if (parseInt(formIds[i].value) != parseInt(formId)) continue;
	
				var form = formIds[i].parentNode;
				if (form.tagName == 'FORM' || form.nodeName == 'FORM') {
					RSFormPro.Forms[formId] = form;
					return form;
				}
	
				while (form.parentNode) {
					form = form.parentNode;
					if (form.tagName == 'FORM' || form.nodeName == 'FORM') {
						RSFormPro.Forms[formId] = form;
						return form;
					}
				}
			}
		}
	
		return RSFormPro.Forms[formId];
	};
	
	RSFormPro.getValue = function (formId, name) {
		var form = RSFormPro.getForm(formId);
		var values = [];
	
		if (typeof form != 'undefined') {
			for (var i = 0; i < form.elements.length; i++) {
				var element = form.elements[i];
				var tagName = element.tagName || element.nodeName;
	
				switch (tagName) {
					case 'INPUT':
						if (element.type) switch (element.type.toUpperCase()) {
							case 'TEXT':
							case 'NUMBER':
							case 'HIDDEN':
								if (!element.name || element.name != 'form[' + name + ']') continue;
								return element.value;
								break;
	
							case 'RADIO':
								if (!element.name || element.name != 'form[' + name + ']') continue;
	
								if (element.checked == true) {
									values.push(element.value);
								}
								break;
	
							case 'CHECKBOX':
								if (!element.name || element.name != 'form[' + name + '][]') continue;
								if (element.checked == true) {
									values.push(element.value);
								}
								break;
						}
						break;
	
					case 'SELECT':
						if (!element.name || element.name != 'form[' + name + '][]') continue;
	
						if (element.options) for (var o = 0; o < element.options.length; o++) {
							if (element.options[o].selected) {
								values.push(element.options[o].value);
							}
						}break;
				}
			}
		}
	
		return values;
	};
	
	RSFormPro.getElementByType = function (formId, type) {
		var form = RSFormPro.getForm(formId);
		type = type.toUpperCase();
		var elements = [];
	
		if (typeof form != 'undefined') {
			for (var i = 0; i < form.elements.length; i++) {
				var element = form.elements[i];
				var tagName = element.tagName || element.nodeName;
				switch (tagName) {
					case 'INPUT':
					case 'BUTTON':
						if (element.type.toUpperCase() == type) {
							elements.push(element);
						}
						break;
	
					case 'SELECT':
					case 'TEXTAREA':
						if (type == 'SELECT' || type == 'TEXTAREA') {
							elements.push(element);
						}
						break;
				}
			}
		}
	
		return elements;
	};
	
	RSFormPro.isChecked = function (formId, name, value) {
		var isChecked = false;
		var form = RSFormPro.getForm(formId);
	
		if (typeof form != 'undefined') {
			primary_loop: for (var i = 0; i < form.elements.length; i++) {
				var element = form.elements[i];
				var tagName = element.tagName || element.nodeName;
	
				switch (tagName) {
					case 'INPUT':
						if (element.type) switch (element.type.toUpperCase()) {
							case 'RADIO':
								if (!element.name || element.name != 'form[' + name + ']') continue;
								if (element.checked == true && element.value == value) {
									isChecked = true;
									break primary_loop;
								}
								break;
	
							case 'CHECKBOX':
								if (!element.name || element.name != 'form[' + name + '][]') continue;
								if (element.checked == true && element.value == value) {
									isChecked = true;
									break primary_loop;
								}
								break;
						}
						break;
	
					case 'SELECT':
						if (!element.name || element.name != 'form[' + name + '][]') continue;
	
						if (element.options) for (var o = 0; o < element.options.length; o++) {
							if (element.options[o].selected && element.options[o].value == value) {
								isChecked = true;
								break primary_loop;
							}
						}break;
				}
			}
		}
	
		return isChecked;
	};
	
	RSFormPro.getBlock = function (formId, block) {
		var form = RSFormPro.getForm(formId);
		var possible = false;
		var blocks, current_block;
	
		if (typeof form != 'undefined') {
			if (blocks = _getElementsByClassName('rsform-block')) {
				for (i = 0; i < blocks.length; i++) {
					var classes = blocks[i].className.split(' ');
					for (c = 0; c < classes.length; c++) {
						if (classes[c] == 'rsform-block-' + block) {
							if (blocks[i].parentNode) {
								current_block = blocks[i];
								if (current_block == form) return [blocks[i]];
	
								while (current_block.parentNode) {
									current_block = current_block.parentNode;
									if (current_block == form) return [blocks[i]];
								}
							}
	
							possible = [blocks[i]];
						}
					}
				}
			}
		}
	
		return possible;
	};
	
	RSFormPro.getFieldsByName = function (formId, name) {
		var form = RSFormPro.getForm(formId);
		var results = [];
		var pushed = false;
	
		if (typeof form != 'undefined') {
			for (var i = 0; i < form.elements.length; i++) {
				var element = form.elements[i];
				pushed = false;
				if (element.name && (
				// single fields
				element.name == 'form[' + name + ']' ||
				// multiple fields
				element.name == 'form[' + name + '][]' ||
				// new field - Birthday field
				element.name == 'form[' + name + '][d]' || element.name == 'form[' + name + '][m]' || element.name == 'form[' + name + '][y]')) {
					results.push(element);
					pushed = true;
				}
	
				if (pushed) {
					// for calendar
					if (element.id && element.id.indexOf('txtcal') > -1) {
						var suffix = element.id.replace('txtcal', '');
						results.push(document.getElementById('btn' + suffix));
					}
					// for labels (radio, checkbox)
					var labels = form.getElementsByTagName('label');
					for (var l = 0; l < labels.length; l++) {
						if (labels[l].htmlFor && labels[l].htmlFor == element.id) results.push(labels[l]);
					}
				}
			}
		}
	
		return results;
	};
	
	/*HTML5 simulators*/
	
	RSFormPro.HTML5 = {
		validation: function validation(formId) {
			var form = RSFormPro.getForm(formId);
			var errorElements = [];
			var html5types = ['number', 'email', 'range', 'url', 'tel'];
	
			var checkValidityExists = true;
			var page = 0;
			if (form.elements.length) {
				for (var i = 0; i < form.elements.length; i++) {
					if (!checkValidityExists) {
						break;
					}
	
					// if the multiple form is present and also validation we will need to find in witch page the element is located
					if (form.elements[i].type == 'button') {
						var onclick = form.elements[i].getAttribute('onclick');
						if (typeof onclick == 'string' && onclick.indexOf('rsfp_changePage') >= 0) {
							var countCommas = 0;
							var pos = onclick.indexOf(',');
							while (pos > -1) {
								++countCommas;
								pos = onclick.indexOf(',', ++pos);
							}
	
							if (countCommas > 2) {
								page++;
							}
						}
					}
					if (html5types.indexOf(form.elements[i].type) >= 0) {
						if (typeof form.elements[i].checkValidity == "function" && checkValidityExists) {
							if (!form.elements[i].checkValidity()) {
								var elementObj = {
									field: form.elements[i],
									page: page
								};
								// try to get the componentId
								var componentId = RSFormPro.HTML5.getComponentId(formId, form.elements[i].getAttribute('id'));
								if (componentId) {
									elementObj.componentId = componentId;
								}
	
								errorElements.push(elementObj);
							}
						} else {
							checkValidityExists = false;
						}
					}
				}
			}
			return errorElements;
		},
	
		componentIds: {},
	
		getComponentId: function getComponentId(formId, elementAlias) {
			if (typeof RSFormPro.HTML5.componentIds[formId] == 'undefined') {
				RSFormPro.HTML5.componentIds[formId] = {};
			}
	
			if (typeof RSFormPro.HTML5.componentIds[formId][elementAlias] == 'undefined') {
				var block = RSFormPro.getBlock(formId, RSFormProUtils.getAlias(elementAlias));
				var componentIdBlock = RSFormProUtils.getElementsByClassName('formNoError', 'span', block[0]);
				if (componentIdBlock.length) {
					var componentId = componentIdBlock[0].getAttribute('id');
					RSFormPro.HTML5.componentIds[formId][elementAlias] = componentId.replace('component', '');
				} else {
					RSFormPro.HTML5.componentIds[formId][elementAlias] = false;
				}
			}
	
			return RSFormPro.HTML5.componentIds[formId][elementAlias];
		}
	};
	
	/* Pagination functions */
	
	RSFormPro.Pages = {
		change: function change(formId, page, totalPages, validate, parentErrorClass) {
			// callback functions if next page is clicked
			var direction = RSFormPro.Pages.checkDirection(formId, page);
			if (direction == 'next') {
				RSFormPro.callbacks.runCallback(formId, 'nextPage');
			}
			RSFormPro.callbacks.runCallback(formId, 'changePage');
	
			var thePage;
	
			if (validate) {
				var form = RSFormPro.getForm(formId);
				if (!RSFormPro.Ajax.validate(form, page, parentErrorClass, totalPages)) {
					return false;
				}
			}
	
			for (var i = 0; i <= totalPages; i++) {
				thePage = document.getElementById('rsform_' + formId + '_page_' + i);
				if (thePage) {
					rsfp_hidePage(thePage);
				}
			}
	
			thePage = document.getElementById('rsform_' + formId + '_page_' + page);
			if (thePage) {
				rsfp_showPage(thePage);
				try {
					var func = window["rsfp_showProgress_" + formId];
					if (typeof func == "function") {
						func(page);
					}
				} catch (err) {}
			}
		},
		hide: function hide(thePage) {
			RSFormProUtils.addClass(thePage, 'formHidden');
		},
		show: function show(thePage) {
			RSFormProUtils.removeClass(thePage, 'formHidden');
		},
	
		checkDirection: function checkDirection(formId, page) {
			var base = RSFormPro.Pages;
			if (typeof base.history[formId] == 'undefined') {
				base.history[formId] = page;
				return 'next';
			} else {
				var direction;
				if (base.history[formId] <= page) {
					direction = 'next';
				} else {
					direction = 'prev';
				}
				base.history[formId] = page;
	
				return direction;
			}
		},
		history: {}
	};
	
	/* Condition functions */
	RSFormPro.Conditions = {
		add: function add(formId, name, fnCondition) {
			var form = RSFormPro.getForm(formId);
	
			if (typeof form != 'undefined') {
				for (var i = 0; i < form.elements.length; i++) {
					var element = form.elements[i];
					var tagName = element.tagName || element.nodeName;
					if (element.name && (element.name == 'form[' + name + ']' || element.name == 'form[' + name + '][]')) {
						if (tagName == 'SELECT') {
							RSFormProUtils.addEvent(element, 'change', function () {
								fnCondition();
							});
						} else {
							RSFormProUtils.addEvent(element, 'click', function () {
								fnCondition();
							});
						}
					}
				}
			}
		},
		runAll: function runAll(formId) {
			var func = window["rsfp_runAllConditions" + formId];
			if (typeof func == "function") {
				func();
			}
		}
	};
	
	/* Calculation functions */
	
	RSFormPro.Calculations = {
		addEvents: function addEvents(formId, fields) {
			var func = window["rsfp_Calculations" + formId];
			var thefields = fields ? fields : RSFormProPrices;
	
			// Detect IE8.
			var isIE8 = navigator.userAgent.match(/MSIE 8\.0/);
			var event = 'click';
	
			for (var field in thefields) {
				if (!thefields.hasOwnProperty(field)) {
					continue;
				}
				field = field.replace(formId + '_', '');
				objects = RSFormPro.getFieldsByName(formId, field);
				for (i = 0; i < objects.length; i++) {
					tagName = objects[i].tagName || objects[i].nodeName;
	
					if (tagName == 'INPUT' || tagName == 'SELECT') {
						// IE8 fix.
						if (tagName == 'INPUT' && isIE8 && objects[i].type && objects[i].type.toLowerCase() == 'checkbox') {
							event = 'click';
						} else {
							event = 'change';
						}
	
						RSFormProUtils.addEvent(objects[i], event, function () {
							if (typeof func == "function") {
								func();
							}
						});
					}
				}
			}
		}
	};
	
	/* AJAX functions */
	RSFormPro.Ajax = {
		URL: false,
		getXHR: function getXHR() {
			try {
				return new window.XMLHttpRequest();
			} catch (e) {}
		},
		displayValidationErrors: function displayValidationErrors(formComponents, task, formId, data) {
			if (task == 'afterSend') {
				var ids, i, j, id, formComponent, firstErrorElement, elementBlock;
	
				ids = data.response[0].split(',');
				for (i = 0; i < ids.length; i++) {
					id = parseInt(ids[i]);
					if (!isNaN(id) && typeof formComponents[id] != 'undefined') {
						formComponent = RSFormPro.getFieldsByName(formId, formComponents[id]);
						if (formComponent && formComponent.length > 0) {
							for (j = 0; j < formComponent.length; j++) {
								if (formComponent[j]) {
									formComponent[j].className = formComponent[j].className.replace(' rsform-error', '');
									if (typeof data.parentErrorClass != 'undefined') {
										try {
											elementBlock = RSFormPro.getBlock(formId, RSFormProUtils.getAlias(formComponents[id]));
	
											elementBlock = elementBlock[0];
											elementBlock.className = elementBlock.className.replace(data.parentErrorClass, '');
										} catch (err) {}
									}
								}
							}
						}
					}
				}
	
				ids = data.response[1].split(',');
				var doScroll = false;
				for (i = 0; i < ids.length; i++) {
					id = parseInt(ids[i]);
					if (!isNaN(id) && typeof formComponents[id] != 'undefined') {
						formComponent = RSFormPro.getFieldsByName(formId, formComponents[id]);
						if (formComponent && formComponent.length > 0) {
							for (j = 0; j < formComponent.length; j++) {
								if (formComponent[j]) {
									formComponent[j].className = formComponent[j].className.replace(' rsform-error', '') + ' rsform-error';
									if (!doScroll) {
										doScroll = true;
									}
									if (typeof data.parentErrorClass != 'undefined') {
										try {
											elementBlock = RSFormPro.getBlock(formId, RSFormProUtils.getAlias(formComponents[id]));
	
											elementBlock = elementBlock[0];
											elementBlock.className = elementBlock.className.replace(data.parentErrorClass, '') + data.parentErrorClass;
										} catch (err) {}
									}
								}
							}
						}
					}
				}
	
				// scroll to first error elment
				if (RSFormPro.scrollToError && doScroll) {
					RSFormPro.gotoErrorElement(formId);
				}
			}
		},
		validate: function validate(form, page, parentErrorClass, totalPages) {
			try {
				var el = form.elements.length;
			} catch (err) {
				form = this;
			}
	
			var xmlHttp = RSFormPro.Ajax.getXHR();
			var url = 'index.php?option=com_rsform&task=ajaxValidate';
			if (typeof RSFormPro.Ajax.URL == 'string') {
				url = RSFormPro.Ajax.URL;
			}
	
			var params = [],
			    submits = [],
			    errorFields = [],
			    success = false,
			    formId = 0,
			    ids,
			    totlaJSDetectedPages = 0,
			    lastClickedElement,
			    i,
			    j;
	
			for (i = 0; i < form.elements.length; i++) {
				// try and detect total pages of the form
				if (form.elements[i].type == 'button') {
					var onclick = form.elements[i].getAttribute('onclick');
					if (typeof onclick == 'string' && onclick.indexOf('rsfp_changePage') >= 0) {
						var countCommas = 0;
						var pos = onclick.indexOf(',');
						while (pos > -1) {
							++countCommas;
							pos = onclick.indexOf(',', ++pos);
						}
	
						if (countCommas > 2) {
							totlaJSDetectedPages++;
						}
					}
				}
	
				// don't send an empty value
				if (!form.elements[i].name) continue;
				if (form.elements[i].name.length == 0) continue;
				// check if the checkbox is checked
				if (form.elements[i].type == 'checkbox' && form.elements[i].checked == false) continue;
				// check if the radio is selected
				if (form.elements[i].type == 'radio' && form.elements[i].checked == false) continue;
	
				if (form.elements[i].type == 'submit' && form.elements[i].getAttribute('data-disableonsubmit') == '1') {
					submits.push(form.elements[i]);
					form.elements[i].disabled = true;
				}
	
				// check if form is a dropdown with multiple selections
				if (form.elements[i].type == 'select-multiple') {
					for (j = 0; j < form.elements[i].options.length; j++) {
						if (form.elements[i].options[j].selected) {
							params.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].options[j].value));
						}
					}
	
					continue;
				}
	
				if (form.elements[i].name == 'form[formId]') {
					formId = form.elements[i].value;
				}
	
				if (typeof RSFormPro.Editors[form.elements[i].name] == 'function') {
					params.push(form.elements[i].name + '=' + encodeURIComponent(RSFormPro.Editors[form.elements[i].name]()));
				} else {
					params.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
				}
			}
	
			errorFields = RSFormPro.HTML5.validation(formId);
	
			if (typeof ajaxExtraValidationScript[formId] == 'function') {
				ajaxExtraValidationScript[formId]('beforeSend', formId, { 'url': url, 'params': params });
			}
	
			if (page) {
				params.push('page=' + page);
			}
	
			params = params.join('&');
	
			xmlHttp.open("POST", url, true);
	
			//Send the proper header information along with the request
			xmlHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			xmlHttp.send(params);
			success = true;
	
			xmlHttp.onreadystatechange = function () {
				if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
					if (xmlHttp.responseText.indexOf("\n") != -1) {
	
						var response = xmlHttp.responseText.split("\n");
						// All spans set to no error
						ids = response[0].split(',');
						for (i = 0; i < ids.length; i++) {
							if (!isNaN(parseInt(ids[i])) && document.getElementById('component' + ids[i])) {
								document.getElementById('component' + ids[i]).className = 'formNoError';
							}
						} // Show errors
						ids = response[1].split(',');
	
						// add the HTML5 elements with errors
						var errorOnPage;
						if (errorFields.length) {
							for (i = 0; i < errorFields.length; i++) {
								if (typeof errorFields[i].componentId != 'undefined') {
									if (typeof page == 'undefined' || page - 1 == errorFields[i].page) {
										ids.push(errorFields[i].componentId);
										if (typeof errorOnPage != 'undefined') {
											errorOnPage = errorFields[i].page < errorOnPage ? errorFields[i].page : errorOnPage;
										} else {
											errorOnPage = errorFields[i].page;
										}
									}
								}
							}
						}
	
						var errorComponents = [];
						for (i = 0; i < ids.length; i++) {
							if (!isNaN(parseInt(ids[i])) && document.getElementById('component' + ids[i])) {
								document.getElementById('component' + ids[i]).className = 'formError';
								errorComponents.push(ids[i]);
								success = false;
							}
						}
	
						// lets detect if the multiple page form is submitted
	
						var changePageHTML5Errors = false;
						if (totlaJSDetectedPages > 0 && RSClickedSubmitElement && submits.indexOf(RSClickedSubmitElement) >= 0 && typeof errorOnPage != 'undefined') {
							changePageHTML5Errors = true;
						}
						//return false;
						if (response.length == 4 || changePageHTML5Errors) {
							if (response.length == 4) {
								page = parseInt(response[2]) - 1;
								totalPages = parseInt(response[3]);
								if (changePageHTML5Errors) {
									page = page > errorOnPage ? errorOnPage : page;
								}
							} else {
								if (changePageHTML5Errors) {
									page = errorOnPage;
									totalPages = totlaJSDetectedPages;
								}
							}
	
							rsfp_changePage(formId, page, totalPages, false);
						}
	
						if (typeof ajaxExtraValidationScript[formId] == 'function') {
							// rewrite the response so that all the error components are added (that includes HTML5 fields)
							if (errorComponents.length) {
								response[1] = errorComponents.join();
							}
							ajaxExtraValidationScript[formId]('afterSend', formId, { 'url': url, 'params': params, 'response': response, 'parentErrorClass': parentErrorClass });
						}
					}
	
					if (success == false) {
						// The submits must be clickable again
						for (i = 0; i < submits.length; i++) {
							submits[i].disabled = false;
						}
	
						try {
							if (typeof page == 'undefined' || page == 0) {
								RSFormPro.callbacks.runCallback(formId, 'afterValidationFailed'); // callback functions if validation fails when form is submitted
							} else {
								RSFormPro.callbacks.runCallback(formId, 'nextPageFailed'); // callback functions if validation fails when a specific page of the form is checked
							}
							if (document.getElementById('rsform_error_' + formId)) {
								document.getElementById('rsform_error_' + formId).style.display = 'block';
							}
						} catch (err) {}
					}
	
					if (success == true) {
						// Change the page if the validation passes
						if (page) {
							rsfp_changePage(formId, page, totalPages, false);
							// The submits must be clickable again
							for (i = 0; i < submits.length; i++) {
								submits[i].disabled = false;
							}
						} else {
							// the submit button has been presed so we need to submit the form
							// if the submit button or any other element has the id submit the form.submit() function is overwritten
							if (typeof form.submit != 'function') {
								document.createElement('form').submit.call(form);
							} else {
								form.submit();
							}
						}
	
						try {
							if (typeof page == 'undefined' || page == 0) {
								RSFormPro.callbacks.runCallback(formId, 'afterValidationSuccess'); // callback functions if validation succeeds
							} else {
								RSFormPro.callbacks.runCallback(formId, 'nextPageSuccess'); // callback functions if validation succeeds when a specific page of the form is checked
							}
							document.getElementById('rsform_error_' + formId).style.display = 'none';
						} catch (err) {}
					}
					return success;
				}
			};
	
			return false;
		}
	};
	
	RSFormPro.callbacks = {
		allCallbacks: {},
	
		addCallback: function addCallback(formId, callbackName, args) {
			var base = RSFormPro.callbacks;
	
			if (typeof base.allCallbacks[formId] == 'undefined') {
				base.allCallbacks[formId] = {};
			}
	
			if (typeof base.allCallbacks[formId][callbackName] == 'undefined') {
				base.allCallbacks[formId][callbackName] = [];
			}
	
			base.allCallbacks[formId][callbackName].push(args);
		},
	
		runCallback: function runCallback(formId, callbackName) {
			var base = RSFormPro.callbacks;
			if (typeof base.allCallbacks[formId] != 'undefined' && typeof base.allCallbacks[formId][callbackName] != 'undefined' && base.allCallbacks[formId][callbackName].length > 0) {
				for (var i = 0; i < base.allCallbacks[formId][callbackName].length; i++) {
					var args = base.allCallbacks[formId][callbackName][i];
					var functionName = args[0];
	
					var functionArgs = [];
					for (var j = 1; j < args.length; j++) {
						functionArgs.push(args[j]);
					}
	
					// execute the callback function set for this trigger
					functionName.apply(self, functionArgs);
				}
			}
		}
	
		/* Helper functions */
	
	};var RSFormProUtils = {
		addEvent: function addEvent(obj, evType, fn) {
			if (obj.addEventListener) {
				obj.addEventListener(evType, fn, false);
				return true;
			} else if (obj.attachEvent) {
				var r = obj.attachEvent("on" + evType, fn);
				return r;
			} else {
				return false;
			}
		},
		hasClass: function hasClass(el, name) {
			return new RegExp('(\\s|^)' + name + '(\\s|$)').test(el.className);
		},
		addClass: function addClass(el, name) {
			if (!RSFormProUtils.hasClass(el, name)) {
				el.className += (el.className ? ' ' : '') + name;
			}
		},
		removeClass: function removeClass(el, name) {
			if (RSFormProUtils.hasClass(el, name)) {
				el.className = el.className.replace(new RegExp('(\\s|^)' + name + '(\\s|$)'), ' ').replace(/^\s+|\s+$/g, '');
			}
		},
		setDisplay: function setDisplay(items, value) {
			for (var i = 0; i < items.length; i++) {
				items[i].style.display = value;
			}
		},
		getAlias: function getAlias(str) {
			str = str.replace(/\-/g, ' ');
	
			if (!String.prototype.trim) {
				str = str.replace(/^\s+|\s+$/g, '');
			} else {
				str = str.trim();
			}
	
			str = str.toLowerCase();
			str = str.replace(/(\s|[^A-Za-z0-9\-])+/g, '-');
			str = str.replace(/^\-+|\-+$/g, '');
	
			return str;
		},
		getElementsByClassName: function getElementsByClassName(className, tag, elm) {
			if (document.getElementsByClassName) {
				_getElementsByClassName = function _getElementsByClassName(className, tag, elm) {
					elm = elm || document;
					var elements = elm.getElementsByClassName(className),
					    nodeName = tag ? new RegExp("\\b" + tag + "\\b", "i") : null,
					    returnElements = [],
					    current;
					for (var i = 0, il = elements.length; i < il; i += 1) {
						current = elements[i];
						if (!nodeName || nodeName.test(current.nodeName)) {
							returnElements.push(current);
						}
					}
					return returnElements;
				};
			} else if (document.evaluate) {
				_getElementsByClassName = function _getElementsByClassName(className, tag, elm) {
					tag = tag || "*";
					elm = elm || document;
					var classes = className.split(" "),
					    classesToCheck = "",
					    xhtmlNamespace = "http://www.w3.org/1999/xhtml",
					    namespaceResolver = document.documentElement.namespaceURI === xhtmlNamespace ? xhtmlNamespace : null,
					    returnElements = [],
					    elements,
					    node;
					for (var j = 0, jl = classes.length; j < jl; j += 1) {
						classesToCheck += "[contains(concat(' ', @class, ' '), ' " + classes[j] + " ')]";
					}
					try {
						elements = document.evaluate(".//" + tag + classesToCheck, elm, namespaceResolver, 0, null);
					} catch (e) {
						elements = document.evaluate(".//" + tag + classesToCheck, elm, null, 0, null);
					}
					while (node = elements.iterateNext()) {
						returnElements.push(node);
					}
					return returnElements;
				};
			} else {
				_getElementsByClassName = function _getElementsByClassName(className, tag, elm) {
					tag = tag || "*";
					elm = elm || document;
					var classes = className.split(" "),
					    classesToCheck = [],
					    elements = tag === "*" && elm.all ? elm.all : elm.getElementsByTagName(tag),
					    current,
					    returnElements = [],
					    match;
					for (var k = 0, kl = classes.length; k < kl; k += 1) {
						classesToCheck.push(new RegExp("(^|\\s)" + classes[k] + "(\\s|$)"));
					}
					for (var l = 0, ll = elements.length; l < ll; l += 1) {
						current = elements[l];
						match = false;
						for (var m = 0, ml = classesToCheck.length; m < ml; m += 1) {
							match = classesToCheck[m].test(current.className);
							if (!match) {
								break;
							}
						}
						if (match) {
							returnElements.push(current);
						}
					}
					return returnElements;
				};
			}
	
			return _getElementsByClassName(className, tag, elm);
		}
	};
	
	function isset() {
		// http://kevin.vanzonneveld.net
		// +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
		// +   improved by: FremyCompany
		// +   improved by: Onno Marsman
		// +   improved by: Rafał Kukawski
		// *     example 1: isset( undefined, true);
		// *     returns 1: false
		// *     example 2: isset( 'Kevin van Zonneveld' );
		// *     returns 2: true
		var a = arguments,
		    l = a.length,
		    i = 0,
		    undef;
	
		if (l === 0) {
			throw new Error('Empty isset');
		}
	
		while (i !== l) {
			if (a[i] === undef || a[i] === null) {
				return false;
			}
			i++;
		}
		return true;
	}
	
	/* Legacy functions */
	
	function rsfp_geolocation(term, id, mapid, map, marker, geocoder, type) {
		return RSFormPro.initGeoLocation(term, id, mapid, map, marker, geocoder, type);
	}
	
	function refreshCaptcha(componentId, captchaPath) {
		return RSFormPro.refreshCaptcha(componentId, captchaPath);
	}
	
	function number_format(number, decimals, dec_point, thousands_sep) {
		return RSFormPro.formatNumber(number, decimals, dec_point, thousands_sep);
	}
	
	function rsfp_toNumber(number, decimal, thousands, decimals) {
		return RSFormPro.toNumber(number, decimal, thousands, decimals);
	}
	
	function rsfp_getForm(formId) {
		return RSFormPro.getForm(formId);
	}
	
	function rsfp_getValue(formId, name) {
		return RSFormPro.getValue(formId, name);
	}
	
	function rsfp_verifyChecked(formId, name, value) {
		return RSFormPro.isChecked(formId, name, value);
	}
	
	function rsfp_getBlock(formId, block) {
		return RSFormPro.getBlock(formId, block);
	}
	
	function rsfp_getFieldsByName(formId, name) {
		return RSFormPro.getFieldsByName(formId, name);
	}
	
	function rsfp_addEvent(obj, evType, fn) {
		return RSFormProUtils.addEvent(obj, evType, fn);
	}
	
	function rsfp_setDisplay(items, value) {
		return RSFormProUtils.setDisplay(items, value);
	}
	
	function stringURLSafe(str) {
		return RSFormProUtils.getAlias(str);
	}
	
	function rsfp_changePage(formId, page, totalPages, validate, parentErrorClass) {
		return RSFormPro.Pages.change(formId, page, totalPages, validate, parentErrorClass);
	}
	
	function rsfp_hidePage(thePage) {
		return RSFormPro.Pages.hide(thePage);
	}
	
	function rsfp_showPage(thePage) {
		return RSFormPro.Pages.show(thePage);
	}
	
	function rsfp_checkValidDate(fieldName) {
		return RSFormPro.disableInvalidDates(fieldName);
	}
	
	function rsfp_addCondition(formId, name, fnCondition) {
		return RSFormPro.Conditions.add(formId, name, fnCondition);
	}
	
	function rsfp_runAllConditions(formId) {
		return RSFormPro.Conditions.runAll(formId);
	}
	
	function rsfp_setCalculationsEvents(formId, fields) {
		return RSFormPro.Calculations.addEvents(formId, fields);
	}
	
	function _getElementsByClassName(className, tag, elm) {
		return RSFormProUtils.getElementsByClassName(className, tag, elm);
	}
	
	function buildXmlHttp() {
		return RSFormPro.Ajax.getXHR();
	}
	
	function ajaxDisplayValidationErrors(formComponents, task, formId, data) {
		return RSFormPro.Ajax.displayValidationErrors(formComponents, task, formId, data);
	}
	
	function ajaxValidation(form, page, parentErrorClass) {
		return RSFormPro.Ajax.validate(form, page, parentErrorClass);
	}
	
	/*** EXPORTS FROM exports-loader ***/
	exports["RSFormPro"] = (RSFormPro);
	exports["rsfp_addEvent"] = (rsfp_addEvent);
	exports["ajaxExtraValidationScript"] = (ajaxExtraValidationScript);
	exports["ajaxDisplayValidationErrors"] = (ajaxDisplayValidationErrors);
	exports["RSClickedSubmitElement"] = (RSClickedSubmitElement);
	exports["ajaxValidation"] = (ajaxValidation);
	exports["RSFormProUtils"] = (RSFormProUtils);
	exports["rsfp_getForm"] = (rsfp_getForm);

/***/ })
]);


// WEBPACK FOOTER //
// bundle.js